<template>
    <div class="integralRule">
         <van-nav-bar
            :title="title"
            left-arrow
            class="main-nav"
            @click-left="onClickLeft"
        />
        <div class="integralRule_top">
            如何获得
        </div>
        <div class="integralRule_cenTitle">
            积分可以通过观看视频、阅读文章等方式获得,具体规则如下:
        </div>
        <div class="integralRule_cenList" v-for="(item,index) in list" :key="index">
            <p class="integralRule_cenList_left">{{item.title}}</p>
            <p class="integralRule_cenList_cen">{{item.num}}</p>
            <p class="integralRule_cenList_right">{{item.dec}}</p>
        </div>
        <div class="integralRule_top">
            如何使用
        </div>
        <div class="integralRule_cenTitle">
            后续可以使用积分兑换课程、礼品,还在开发中哦, 敬请期待~
        </div>
    </div>
</template>
<script>
import {verticalScreen} from '../../assets/js/vertical-screen';
export default {
name: 'integral-rule',
data() {
    return {
        title:'积分规则',
        list:[
            {
                title:'登录',
                num:'1分',
                dec:'(每日上限1分)'
            },
            {
                title:'文章',
                num:'2分',
                dec:'(从头滑到底且停留5秒,每个文章上限2分)'
            },
            {
                title:'视频',
                num:'4分',
                dec:'(快进则完成不记分每个视频上限4分)'
            },
        ]
    }
},
mounted() {
    verticalScreen();
},
methods: {
    onClickLeft() {
        this.$router.go(-1);
    },
},
created() {

}
}
</script>
<style lang="scss" scoped>
.integralRule {
    padding:0 15px;
    .integralRule_top {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FF8340;
        line-height: 22px;
        margin-top: 20px;
        margin-bottom: 8px;
    }
    .integralRule_cenTitle {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
    }
    .integralRule_cenList {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        margin-bottom: 15px;
        display: flex;
        .integralRule_cenList_cen {
            color: #FF8334;
            margin-left: 5px;
            margin-right: 5px;
            text-align: left;
        }
        .integralRule_cenList_right {
            color: #666;
        }
    }
    ::v-deep .van-icon {
        color: #000;
    }
}
</style>